import {IMGPW} from '@/config';
import Image from 'next/image';
import {Swiper, SwiperSlide} from 'swiper/react';

function SectionAds() {
  return (
    <section className="tw-bg-gray-200 tw-py-24">
      <div className="container tw-space-y-8 md:tw-space-y-16">
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-5 tw-gap-8 md:tw-gap-16">
        <div className="md:tw-col-span-2">
          <h3 className="tw-text-4xl tw-font-bold tw-tracking-tighter tw-text-black tw-mb-4 tw-text-gray-800">
            Eine starke Marke
          </h3>
          <div className="tw-text-base md:tw-text-lg tw-font-medium tw-tracking-tight">
            Dank einer Vielzahl von nationalen Kommunikationskampagnen
            sowohl im <strong>Fernsehen</strong> als auch digital, ist Winelivery
            heute eine bekannte Marke in ganz <strong>Italien</strong>.
          </div>
        </div>
        <div className="md:tw-col-span-3">
          <Swiper slidesPerView={1.5} spaceBetween={24}>
            <SwiperSlide>
              <div className="tw-space-y-2">
                <div className="tw-w-full tw-h-64 tw-object-cover rounded position-relative">
                  <Image
                    fill
                    style={{objectFit: 'cover'}}
                    src={`${IMGPW}/Maglietta.png`}
                    alt="Sponsorship Hellas Verona 2020"
                    className="rounded"
                  />
                </div>
                <div className="tw-text-base md:tw-text-lg tw-font-medium tw-tracking-tight tw-text-gray-600">
                  Sponsoring Hellas Verona 2020
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="tw-space-y-2">
                <div className="tw-w-full tw-h-64 tw-object-cover rounded position-relative">
                  <Image
                    fill
                    style={{objectFit: 'cover'}}
                    src={`${IMGPW}/spot_1.png`}
                    alt="Spot 1"
                    className="rounded"
                  />
                </div>
                <div className="tw-text-base md:tw-text-lg tw-font-medium tw-tracking-tight tw-text-gray-600">
                  TV-Spot 2022
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="tw-space-y-2">
                <div className="tw-w-full tw-h-64 tw-object-cover rounded position-relative">
                  <Image
                    fill
                    style={{objectFit: 'cover'}}
                    src={`${IMGPW}/spot_2.png`}
                    alt="Spot 2"
                    className="rounded"
                  />
                </div>
                <div className="tw-text-base md:tw-text-lg tw-font-medium tw-tracking-tight tw-text-gray-600">
                  TV-Spot 2021
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="tw-space-y-2">
                <div className="tw-w-full tw-h-64 tw-object-cover rounded position-relative">
                  <Image
                    fill
                    style={{objectFit: 'cover'}}
                    src={`${IMGPW}/spot_3.png`}
                    alt="Spot 3"
                    className="rounded"
                  />
                </div>
                <div className="tw-text-base md:tw-text-lg tw-font-medium tw-tracking-tight tw-text-gray-600">
                  TV-Spot 2020
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
        {/*<hr className="tw-border-amber-800" />*/}
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-8">
          <span className="tw-hidden md:tw-block tw-font-medium tw-text-sm tw-tracking-tight tw-text-gray-600 tw-shrink-0">
            Erscheint in:
          </span>
          <div className="tw-h-10 tw-w-10 rounded position-relative">
            <Image
              fill
              style={{objectFit: 'contain'}}
              src={`${IMGPW}/logo_rai.png`}
              alt="Logo Rai"
              className="rounded"
            />
          </div>
          <div className="tw-h-12 tw-w-24 rounded position-relative">
            <Image
              fill
              style={{objectFit: 'contain'}}
              src={`${IMGPW}/logo_meta.png`}
              alt="Logo Meta"
              className="rounded"
            />
          </div>
          <div className="tw-h-12 tw-w-24 rounded position-relative">
            <Image
              fill
              style={{objectFit: 'contain'}}
              src={`${IMGPW}/logo_discovery.png`}
              alt="Logo Discovery"
              className="rounded"
            />
          </div>
          <div className="tw-h-8 tw-w-32 rounded position-relative">
            <Image
              fill
              style={{objectFit: 'contain'}}
              src={`${IMGPW}/logo_mediaset.png`}
              alt="Logo Mediaset"
              className="rounded"
            />
          </div>
          <div className="tw-h-10 tw-w-16 rounded position-relative">
            <Image
              fill
              style={{objectFit: 'contain'}}
              src={`${IMGPW}/logo_sky.png`}
              alt="Logo Sky"
              className="rounded"
            />
          </div>
          <div className="tw-h-8 tw-w-12 rounded position-relative">
            <Image
              fill
              style={{objectFit: 'contain'}}
              src={`${IMGPW}/logo_la7.png`}
              alt="Logo La7"
              className="rounded"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default SectionAds;
